import {Route} from '@angular/router';
import {AppLayoutComponent} from "./layout/app.layout.component";
import {NotfoundComponent} from "./modules/base/components/notfound/notfound.component";
import {NoAuthGuard} from "./core/auth/guards/no-auth.guard";
import {AuthGuard} from "./core/auth/guards/auth.guard";
import {LoginComponent} from "./modules/auth/login/login.component";
import {
  InternalDocumentationsViewComponent
} from "./modules/documentation-view/internal-documentations-view/internal-documentations-view.component";
import { Error2Component } from './modules/auth/error2/error2.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  // Redirect empty path to '/counties'
  { path: '', pathMatch: 'full', redirectTo: 'manage-portals' },
  // Auth routes for guests
  {
    path: 'auth',
    canActivate: [NoAuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'sign-in' },
      {
        path: 'sign-in', pathMatch: 'full', component: LoginComponent,//AppComponent
      }
    ]
  },
  {
    path: 'manage-portals',
    canActivate: [AuthGuard],
    children: [
      {
        component: AppLayoutComponent,
        path: '', pathMatch: 'full',
        loadChildren: () => import('./modules/manage-portals/manage-portals.routes'),
      }
    ]
  },
  // Admin routes for authenticated users
  {
    path: 'capps-portal',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      // { path: 'counties', pathMatch: 'full', loadChildren: () => import('./modules/base/components/counties/counties.routes') },
      { path: 'users', loadChildren: () => import('./modules/base/components/users/users.routes') },
      { path: 'vehicle', loadChildren: () => import('./modules/base/components/vehicle-list/vehicle-list.routes') },
      { path: 'invoices', loadChildren: () => import('./modules/base/components/invoices/account-invoices.routes') },
      { path: 'invoices/:id/invoices-details', loadChildren: () => import('./modules/base/components/invoices/account-invoice-details/account-invoice-details.routes') },
      { path: 'pricing-plans', loadChildren: () => import('./modules/base/components/pricing-plans/pricing-plans.routes') },
      { path: 'vehicle-types', loadChildren: () => import('./modules/base/components/vehicle-types/vehicle-types.routes') },
      { path: 'setting', loadChildren: () => import('./modules/base/components/settings/settings.routes') },
    ]
  },
  {
    path: 'documentations',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'internal-products-documentations', loadChildren: () => import('./modules/base/components/documentations/internal-documentations/internal-documentation.routes') },
      { path: 'public-products-documentations', loadChildren: () => import('./modules/base/components/documentations/public-documentations/public-documentation.routes') },
    ]
  },
  {
    path: 'county-portal',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'entities', loadChildren: () => import('./modules/manage-county-portals/county-portal-entities/county-portal-entities.routes') },
      { path: 'users', loadChildren: () => import('./modules/manage-county-portals/county-portal-users/county-portal-users.routes') },
      { path: 'notification-setup', loadChildren: () => import('./modules/manage-county-portals/county-portal-notification-setup/county-portal-notification-setup.routes') },
      { path: 'entity-urls', loadChildren: () => import('./modules/manage-county-portals/homestead-credit-url/homestead-credit-url.routes') },
      { path: 'manage-learn-more', loadChildren: () => import('./modules/manage-county-portals/manage-learn-more/manage-learn-more.routes') },
      { path: 'valid-parcels', loadChildren: () => import('./modules/manage-county-portals/valid-parcels/valid-parcels.routes') },
      { path: 'roles-permissions-manage', loadChildren: () => import('./modules/manage-county-portals/roles-permission-manage/roles-permission-manage.routes') },
    ]
  },
  {
    path: 'general',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'release-details', loadChildren: () => import('./modules/general/release-details/release-details.routes') },
      { path: 'logs', loadChildren: () => import('./modules/general/log-detail/log-detail.routes') },
      { path: 'counties', pathMatch: 'full', loadChildren: () => import('./modules/base/components/counties/counties.routes') },
      { path: 'counties/:id/users', loadChildren: () => import('./modules/base/components/counties/county-users/county-users.routes') },
      // { path: 'notification-setup', loadChildren: () => import('./modules/manage-county-portals/county-portal-notification-setup/county-portal-notification-setup.routes') },
      // { path: 'entity-urls', loadChildren: () => import('./modules/manage-county-portals/homestead-credit-url/homestead-credit-url.routes') },
      // { path: 'manage-learn-more', loadChildren: () => import('./modules/manage-county-portals/manage-learn-more/manage-learn-more.routes') },
    ]
  },
  {
    path: 'documentations-portal',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'internal/view/:bookMarkUniqueId', pathMatch: 'full', component: InternalDocumentationsViewComponent,
      },
      {
        path: 'internal/view/:productTypeEnum/:bookMarkUniqueId',
        pathMatch: 'full',
        component: InternalDocumentationsViewComponent,
      },
    ]
  },
  {
    path: 'users',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', loadChildren: () => import('./modules/users-list/user-list.routes') },
    ]
  },
  {
    path: 'access-denied',component: Error2Component, data: {
      title: 'Permission Denied',
    }
  },
  // Wild card routes (unknown route)
  {
    path: '**', title: 'Page Not Found', component: NotfoundComponent, data: {
      title: 'Page Not Found',
    }
  },
];
